module.exports = __webpack_public_path__ + "img/logo.85f1c18e.svg";